import { createStyles, makeStyles } from "@material-ui/core"
import { FC } from "react"
import { VictoryAxis, VictoryBar, VictoryChart, VictoryGroup } from "victory"
import { colors } from "../../utils/theme"
import { MoodBarChartProps } from "../../utils/types"
import MoodBarIconLabel from "./MoodBarIconLabel"
import MoodGraphLegend from "./moodGraphLegend/MoodGraphLegend"
import MoodGroupIcons from "./MoodGroupIcons"

const MoodBarChartWeekly: FC<MoodBarChartProps> = ({ data = [] }) => {
  const classes = useStyles()
  const showLegend =
    data.filter((data) => data.growth !== undefined && data.growth !== null)
      .length > 0

  return (
    <>
      <div className={classes.container}>
        <VictoryChart
          height={330}
          width={1200}
          style={{ parent: { zIndex: 1 } }}
          domain={{ x: [1, 7], y: [0, 5] }}
          padding={{ top: 10, bottom: 48, left: 48, right: 48 }}
          // I've had to skew the height and width
          // because the chart doesn't like these dimensions
        >
          <VictoryAxis
            axisValue={-0.2}
            style={{
              axis: {
                stroke: "none",
              },
              tickLabels: {
                fontSize: 12,
                color: colors.neutral.asphalt,
                fontFamily: "Lato",
                fontWeight: 400,
                letterSpacing: 0.3,
              },
            }}
          />
          <VictoryAxis
            axisValue={1}
            domain={{ x: [0.5, 7.5] }}
            style={{
              axis: { stroke: colors.neutral.clay },
              tickLabels: { fill: "none" },
            }}
          />
          <VictoryAxis
            axisValue={2}
            style={{
              axis: { stroke: colors.neutral.clay },
              tickLabels: { fill: "none" },
            }}
          />
          <VictoryAxis
            axisValue={3}
            style={{
              axis: { stroke: colors.neutral.clay },
              tickLabels: { fill: "none" },
            }}
          />
          <VictoryAxis
            axisValue={4}
            style={{
              axis: { stroke: colors.neutral.clay },
              tickLabels: { fill: "none" },
            }}
          />
          <VictoryAxis
            axisValue={5}
            style={{
              axis: { stroke: "none" },
              tickLabels: { fill: "none" },
            }}
          />
          <VictoryAxis
            dependentAxis
            tickLabelComponent={<MoodGroupIcons />}
            style={{
              axis: { stroke: "none" },
            }}
          />
          <VictoryGroup offset={25}>
            <VictoryBar
              data={data}
              barWidth={5}
              x={(datum) => datum.date.format("dd")}
              y="enjoyment"
              // Victory.js passes params to the custom label but won't let me
              // access the params. Ignoring error
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              /// @ts-expect-error
              labelComponent={<MoodBarIconLabel />}
              cornerRadius={{
                topLeft: -2,
                topRight: -2,
              }}
              style={{
                data: {
                  fill: colors.secondary.grapefruit,
                  strokeWidth: 12,
                },
              }}
            />
            <VictoryBar
              data={data}
              barWidth={5}
              x={(datum) => datum.date.format("dd")}
              y="growth"
              domain={{ x: [1, 7], y: [0, 5] }}
              // Victory.js passes params to the custom label but won't let me
              // access the params. Ignoring error
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              /// @ts-expect-error
              labelComponent={<MoodBarIconLabel />}
              cornerRadius={{
                topLeft: -2,
                topRight: -2,
              }}
              style={{
                data: {
                  fill: colors.primary.periwinkle,
                  strokeWidth: 12,
                },
              }}
            />
          </VictoryGroup>
        </VictoryChart>
        <div className={classes.graphBorder} />
      </div>
      <MoodGraphLegend showGrowth={showLegend} />
    </>
  )
}

export default MoodBarChartWeekly

const useStyles = makeStyles(() =>
  createStyles({
    // This container requires exact positioning
    graphBorder: {
      position: "absolute",
      top: 0,
      left: "4%",
      border: `1px solid ${colors.neutral.clay}`,
      borderRadius: 4,
      width: "92%",
      height: "85%",
    },
    container: {
      position: "relative",
    },
  })
)
